<div id="title">
  {{ title }}
</div>
<ionic-selectable
  [items]="clients$ | async"
  [(ngModel)]="selectedClient"
  [canSearch]="true"
  [canClear]="true"
  itemValueField="id"
  itemTextField="fullname"
  (onChange)="changed.emit($event.value)"
  [shouldFocusSearchbar]="true"
></ionic-selectable>
